
import { Legend } from '..';
import { isNullOrUndefined } from '../../_helpers';
export class LegendGroup {
    key: string;
    items: LegendItem[];
    selected: boolean;
    //position de la légende, ceux sans position sont mis en 1e place
    position: number;

    constructor(_iKey: string, _iItems: LegendItem[], _iPosition: number = 0, _iIsSelected: boolean = false) {
        this.key = _iKey;
        this.items = _iItems;
        this.position = _iPosition;
        this.selected = _iIsSelected
    }
    /**
     * Retourne si il dispose d'item
     * @returns 
     */
    public Exists(): boolean {
        return this.items != null && this.items.length > 0;
    }

    /**
     * Suppression réinitilisation de la liste des items de la légende
     * @returns 
     */
    public RemoveItems():boolean{
        this.items = [];
        return this.items.length ==0
    }
}

/**
 * Ensemble des propriétés de synthèse de légende groupe
 */
export class LegendItem {
    name: string;
    style: Legend;
    legendName: string;
    legendCode: string = null;
    //Ordonne sur cette propriete
    sortOn: string = null;
    unit: string;
    hasSubMenu: boolean;

    items: LegendItem[];
    //propriete externe pour gestion autre propriete
    externeProp: LegendExtProperty = null;
    //Style de donnée de base
    Basicstyle: Legend = null;
    id?: number;
    //indique que la preconisation tech peut être dupliquée en farmer previs (gestion farmer previs)
    canBeFarmerDuplicated?: boolean = null;
    //indique que la previsionnelle farmer peut être modifiée (gestion farmer previs)
    canBeFarmerUpdated?: boolean = null;
    //propriété optionnelle
    options?: string = null;

    //identifiant unique formaté (utile sur la gestion farmer previs)
    uniqueFormatedId?: string = null;
}

export class LegendProperties {
    legendGroupKey: string;
    legendItemKey: string;
    legendProperies: LegendProperty[];
}

/**
 * Ligne pour une propriété micro-parcelle dans la synthèse affichée en tooltip à la micro
 */
export class LegendProperty {

    //#region properties
    /**clés identifiant le nom cas de doublon de nom  propertyKey == legendSelected.Name */
    propertyKey: string | undefined = undefined;
    /**nom affiché propertyName == legendSelected.legendName */
    propertyName: string;
    /**valeur de la propriété */
    propertyValue: string;
    /**unité liée à la valeur */
    unit: string;
    /** Si on visualise cette donnée dans la synthèse */
    isShownInTooltip: boolean;
    /**suffix texte à afficher après la valeur */
    sfxValue: string;
    /**indentation avec une puce */
    identText: boolean = false;
    /**true:si pas de valeur (propertyValue) on affiche un espace vide si false: on  affiche si rien 'Non défini(e)' comme valeur*/
    allowNullValue: boolean = false;
    /**niveau de la synthèse le nom sera en gras seulement si ceci est à false, sinon en gras si c est la propriété selectionnée */
    onlyBoldIfSelected: boolean = false;
    //#endregion

    /**
     * Init
     * @param _iPropertyName nom de la propriété micro affichée dans la synthèse tooltip
     * @param _iPropertyValue valeur
     * @param _iUnit unité ajouté à la valeur
     * @param _iSfxValue sufix de la valeur
     * @param _iShownInTooltip true:visialise dans la synthèse
     * @param _iPropkey clés identifiant le nom cas de doublon de nom si présent   propertyKey == legendSelected.Name
     * @param [_iOnlyBoldIfSelected=false]  niveau de la synthèse le nom sera en gras seulement si ceci est à false, sinon en gras si c est la propriété selectionnée
     * @param _iIdentWithLi indique si on indent avec une puce la ligne
     * @param _iAllowNullValue true on authorise la valeur à null si non on affiche ('Non défini(e)')
     */
    public constructor(_iPropertyName: string, _iPropertyValue: string, _iUnit: string = '', _iSfxValue: string = '', _iShownInTooltip: boolean = true, _iPropkey: string = undefined, _iOnlyBoldIfSelected: boolean = false, _iIdentWithLi: boolean = false, _iAllowNullValue: boolean = false) {
        this.propertyKey = !isNullOrUndefined(_iPropkey) ? _iPropkey : undefined;
        this.propertyName = _iPropertyName;
        this.propertyValue = _iPropertyValue;
        this.unit = _iUnit;
        this.isShownInTooltip = _iShownInTooltip == true;
        this.sfxValue = _iSfxValue;
        this.identText = _iIdentWithLi;
        this.allowNullValue = _iAllowNullValue;
        this.onlyBoldIfSelected = _iOnlyBoldIfSelected;
    }

}
/**reprend donnees pour reconstituer une legende externe */
export class LegendExtProperty {
    propertyName: string;
    //valeur maximal
    propertyValue: number;
    //valeur minimale
    propertyMinValue: number;
    unit: string;
    /**
     *
     * @param _iPropName
     * @param _iPropMaxValue Maximum de la propriete ( pour calcul de la legende rang max value)
     * @param _iPropUnit
     * @param _iPropMinValue minimal de la propriete ( pour calcul de la legende rang min value)
     */
    constructor(_iPropName: string, _iPropMaxValue: number, _iPropUnit: string, _iPropMinValue: number = null) {
        this.propertyName = _iPropName;
        this.propertyValue = _iPropMaxValue;
        this.unit = _iPropUnit;
        this.propertyMinValue = _iPropMinValue;
    }
}
